import { createSlice } from "@reduxjs/toolkit";

export const initialSectionalContentState = {};

const sectionalContentSlice = createSlice({
    name: "sectionalContent",
    initialState: initialSectionalContentState,
    reducers: {
        receive: (state, action) => {
            if (
                action.payload?.section &&
                action.payload?.sectionList instanceof Array
            ) {
                // Update the current section's object in the state
                return {
                    ...state,
                    [action.payload.section]: {
                        section: action.payload.section,
                        sectionList: action.payload.sectionList,
                        timestamp: action.payload.timestamp,
                        isLoaded: true,
                    },
                };
            }
        },
        fetch_error: (state, action) => {
            return {
                ...state,
                [action.payload.section]: {
                    ...state,
                    section: action.payload.section,
                    isLoaded: true,
                },
            };
        },
    },
});

export const {
    receive: receive_sectional_content,
    fetch_error: sectional_content_fetch_error,
} = sectionalContentSlice.actions;

export default sectionalContentSlice.reducer;
